export default "__VITE_ASSET__D4DTM9nF__"